import fetch from "./fetch";
// 菜单、权限、角色、用户相关api
/**
 * 权限
 */
const login = {
  //登录
  // loginInfo(data, projectId) {
  //   return fetch({
  //     isLoading: true,
  //     url: `/v1/sys/login?projectId=${projectId}`,
  //     method: "POST",
  //     data,
  //   });
  // },
  loginInfo(data) {
    return fetch({
      isLoading: true,
      url: "/v1/sys/login",
      method: "POST",
      data,
    });
  },
  //预登录
  beforeLoginInfo(data) {
    return fetch({
      isLoading: true,
      url: "/v1/sys/beforeLogin",
      method: "POST",
      data,
    });
  },
};

export default login;
